import React from "react";
import { useHistory } from "react-router-dom";
import { thousandFormat } from "../../actions/utiles";

function GroupListItem({ group, onRemove }) {
  const link = useHistory();

  const onMoveTolink = (params) => {
    link.push(`${params}`);
  };

  const getStatusText = (status) => {
    if (status) {
      return status === 100 ? "정상" : status === 200 ? "정지" : "사용 불가";
    }
  };

  const getCardNameText = () => {
    const text =
      group.nickname === null
        ? "-"
        : group.protected_number !== null
        ? `${group.nickname}(${group.protected_number})`
        : `${group.nickname}(세금계산서 발급)`;
    return text;
  };

  return (
    <>
      {group && (
        <>
          <tr key={group.key}>
            <th>
              <span
                className="underline-black underline-hover-blue cursor"
                onClick={() => onMoveTolink(`/group-detail/${group.id}`)}
              >
                {group.name}
              </span>
            </th>
            <th>
              <p className="mb-0 txt-dark-gray mr-2">
                {group.count_employee}명
              </p>
              <button className="btn-white pr-1 pl-1">
                <span
                  className="font-bold txt-dark-gray font-small"
                  onClick={() => onMoveTolink(`/group-employee/${group.id}`)}
                >
                  직원 지정
                </span>
              </button>
            </th>
            <th>
              <span className="txt-dark-gray">
                <p className="mb-0">
                  {getCardNameText()}
                </p>
              </span>
            </th>
            <th>
              <span className="txt-dark-gray">
                {group.unpaid_fare
                  ? thousandFormat(group.unpaid_fare) + "원"
                  : "-"}
              </span>
            </th>
            <th>
              <span className="txt-dark-gray">
                {group.use_limit
                  ? thousandFormat(group.use_limit) + "원"
                  : "제한없음"}
              </span>
            </th>
            <th>
              <span
                className={`${
                  group.status !== 100 ? "txt-red" : "txt-dark-gray"
                }`}
              >
                {getStatusText(group.status)}
              </span>
            </th>
            <th>
              <button
                className="btn-white-sm pr-2 pl-2"
                onClick={() => onRemove(group.id)}>
                삭제
              </button>
            </th>
          </tr>
        </>
      )}
    </>
  );
}

export default GroupListItem;
